import AssessmentForm from "@container/asess-section/assessment-form";
import AuthLayout from "@container/layout/auth";

export default function EmployerAssessFormCreatePage() {
    return (
        <AuthLayout>
            <AssessmentForm />
        </AuthLayout>
    );
}
